<template>
    <!-- BUSCADOR -->
    <b-card class="contenedor">

        <!-- Titulo -->
        <div slot="header" class="font-weight-bold">Análisis de riesgos - Análisis</div>

        <!-- Filtros -->
        <div class="row">
            <!-- Tipo -->
            <div class="form-group col-md-3" v-if="setTypes.length > 1">
                <label for="types"> Tipo : </label>
                <el-select id="types" name="types" filterable v-model="filtros.type" placeholder="Seleccione una opción"
                    size="small" @change="getForCompany">
                    <el-option v-for="type in setTypes" :key="type.id" :label="type.name" :value="type.id" />
                </el-select>
            </div>

            <!-- Empresa -->
            <div class="form-group col-md-3" v-if="mostrar_filtro">
                <label for="id_empresa">
                    Empresa <span class="text-danger" v-text="'(*)'" /> :
                </label>
                <el-select id="id_empresa" name="id_empresa" filterable clearable v-model="filtros.id_empresa"
                    placeholder="Seleccione una opción" @change="changeCompany" size="small" remote
                    :remote-method="obtenerEmpresasFiltro">
                    <el-option v-for="empresa in empresas_filtro" :key="empresa.id" :label="empresa.nombre"
                        :value="empresa.id" />
                </el-select>
            </div>

            <!-- País -->
            <div class="form-group col-md-3"
                v-if="filtros.id_empresa && allCountries.length >= 1 && filtros.type === 1">
                <label for="country_id"> País : </label>
                <el-select id="country_id" name="country_id" filterable clearable v-model="country_id"
                    placeholder="Seleccione una opción" size="small" @change="afterChangeCountry">
                    <el-option v-for="item in allCountries" :key="item.country.id" :label="item.country.name"
                        :value="item.country.id" />
                </el-select>
            </div>

            <!-- Ubicación -->
            <div class="form-group col-md-3" v-if="filtros.type === 1 && filtros.id_empresa">
                <label for="id_ubicacion"> Ubicación : </label>
                <tree-select :value="filtros.id_ubicacion" :multiple="true" :defaultExpandLevel="Infinity"
                    :options="treeWithChildrens" :normalizer="normalizer" :show-count="true"
                    value-consists-of="ALL_WITH_INDETERMINATE" :disabled="!filtros.id_empresa"
                    @input="establecerIdUbicacionFiltro" placeholder="Seleccione una opción" />
            </div>

            <!-- GES -->
            <div class="form-group col-md-3" v-if="filtros.type === 2">
                <label for="ges" class="w-100"> GES : </label>
                <el-select class="w-100" filterable placeholder="Buscar GES" size="small" remote clearable
                    v-model="filtros.hygienic_measurement_id" @change="filtersAnalysis">
                    <el-option v-for="hygienicMeasurement in hygienicMeasurements" :key="hygienicMeasurement.id"
                        :label="hygienicMeasurement.name" :value="hygienicMeasurement.id" />
                </el-select>
            </div>

            <!-- Fecha -->
            <div class="form-group col-md-3">
                <label for="fecha" class="w-100"> Fecha : </label>
                <el-date-picker v-model="filtros.fechas" name="fecha" id="fecha" type="daterange" size="small"
                    class="w-100" value-format="yyyy-MM-dd" format="yyyy-MM-dd" align="right" unlink-panels
                    range-separator="-" start-placeholder="Desde" end-placeholder="Hasta"
                    :picker-options="picker_options" @change="filtersAnalysis" />
            </div>

            <!-- Tarea -->
            <div class="form-group col-md-3" v-if="filtros.type === 1">
                <label for="tarea"> Tarea : </label>
                <b-form-input id="proceso" name="proceso" type="text" v-model="filtros.tarea"
                    class="form-input-group" />
            </div>


            <!-- Fabricante -->
            <!-- <div class="form-group col-md-3" v-if="filtros.type === 1">
                <label for="id_fabricante"> Fabricante : </label>
                <el-select id="id_fabricante" name="id_fabricante" filterable clearable
                    popper-class="el-select-personalizado" v-model="filtros.id_fabricante"
                    placeholder="Seleccione una opción" size="small" @change="obtenerProductosFiltro" remote
                    :remote-method="obtenerFabricantesFiltro">
                    <el-option v-for="fabricante in fabricantes_filtro" :key="fabricante.id" :label="fabricante.nombre"
                        :value="fabricante.id" />
                </el-select>
            </div> -->

            <!-- Producto -->
            <div class="form-group col-md-3" v-if="filtros.type === 1">
                <label for="id_producto"> Producto : </label>
                <el-select id="id_producto" name="id_producto" filterable clearable multiple
                    v-model="filtros.id_producto" placeholder="Seleccione una opción" size="small" remote
                    :remote-method="obtenerProductos">
                    <el-option v-for="producto in productos" :key="producto.id" :label="producto.nombre"
                        :value="producto.id">
                        <div>
                            <span class="font-weight-bold">{{ producto.fabricante ? producto.fabricante.nombre + ' - ' :
                                '' }}</span>
                            {{ producto.nombre }}
                        </div>
                    </el-option>
                </el-select>
            </div>

            <!-- Profesional -->
            <div class="form-group col-md-3" v-if="mostrar_filtro && filtros.type === 1">
                <label for="id_usuario_creacion" class="w-100"> Profesional : </label>
                <el-select id="id_usuario_creacion" name="id_usuario_creacion" filterable clearable
                    v-model="filtros.id_usuario_creacion" placeholder="Seleccione una opción" size="small">
                    <el-option v-for="usuario in usuarios" :key="usuario.id" :label="usuario.name"
                        :value="usuario.id" />
                </el-select>
            </div>
        </div>

        <!-- Botones de acciones -->
        <div class="row mb-3">

            <!-- Botones de acciones - Buscar y limpiar filtros -->
            <div class="col-md-6 text-left">
                <b-button variant="primary" class="mr-2 mx-1" @click.prevent="search" :disabled="!filtros.id_empresa">
                    <i class="fa fa-search fa-lg" /> Buscar
                </b-button>

                <b-button @click.prevent="filterClear" variant="light" class="mx-1">
                    <i class="fa fa-eraser fa-lg" /> Limpiar
                </b-button>
            </div>

            <!-- Botones de acciones - Acciones generales -->
            <div class="col-md-6 text-right mt-2">
                <b-dropdown id="actions-available" text="Acciones disponibles" class="m-md-2" variant="primary">
                    <b-dropdown-item to="/analisis-de-riesgos/graficas"
                        v-if="validarPermisoComponente('modulo-analisis-riesgos-graficas') && filtros.type === 1">
                        <i class="fa fa-pie-chart" /> Ver graficos
                    </b-dropdown-item>
                    <b-dropdown-item to="/analisis-de-riesgos/analisis/formulario"
                        v-if="validarPermisoComponente('modulo-analisis-riesgos-formulario') && filtros.type === 1">
                        <i class="fa fa-plus" /> Nuevo análisis INRS
                    </b-dropdown-item>
                    <b-dropdown-item to="/analisis-de-riesgos/analysis-aiha" v-if="filtros.type === 2">
                        <i class="fa fa-plus" /> Nuevo análisis AIHA
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item :disabled="!filtros.id_empresa || !tareas.data.length > 0" @click="descargarExcel"
                        v-if="validarPermisoComponente('descargar-tareas-analisis-riesgos') && filtros.type === 1">
                        <i class="fa fa-file-excel-o text-green" /> Descargar excel
                    </b-dropdown-item>
                    <b-dropdown-item :disabled="!filtros.id_empresa || !tareas.data.length > 0"
                        @click="onHandleDownloadConcept"
                        v-if="validarPermisoComponente('analisis-riesgos-descargar-concepto-en-word') && filtros.type === 1">
                        <i class="fa fa-file-word-o text-blue" /> Descargar concepto - WORD
                    </b-dropdown-item>
                    <b-dropdown-item :disabled="!filtros.id_empresa" v-if="filtros.type === 2"
                        @click="downloadExcelAiha">
                        <i class="fa fa-file-excel-o text-green" /> Descargar excel
                    </b-dropdown-item>
                </b-dropdown>
            </div>

        </div>

        <div v-if="filtros.type === 1">
            <!-- Tabla histórico -->
            <div class="row">
                <div class="col-12">
                    <b-table responsive hover :items="tareas.data" :fields="columns"
                        empty-text="No hay tareas para mostrar" show-empty>
                        <!-- SELECCIÓN -->
                        <template v-slot:cell(seleccion)="data" v-if="mostrar_filtro">
                            <el-checkbox :value="filtros.ids.includes(data.item.id)"
                                @change="toggleIdFiltro(data.item.id)" />
                        </template>

                        <!-- UBICACIONES -->
                        <template v-slot:cell(locations)="data">
                            {{ getLocations(data.item.locations) }}
                        </template>


                        <!-- ESTADO -->
                        <template v-slot:cell(activo)="data">
                            <b-badge v-if="data.item.activo" variant="primary" v-text="'Activo'" />
                            <b-badge v-else variant="danger" v-text="'Inactivo'" />
                        </template>

                        <template v-slot:cell(acciones)="data">

                            <b-dropdown v-if="data.item.activo" id="dropdown-1" text="Opciones" size="sm" class="m-md-2"
                                boundary="window" boundary-padding="10">
                                <b-dropdown-item variant="primary"
                                    :to="`/analisis-de-riesgos/analisis/formulario/${data.item.id}/${data.item.id_empresa}`">
                                    <i class="fa fa-edit text-primary" /> Editar
                                </b-dropdown-item>

                                <b-dropdown-item v-if="mostrar_filtro"
                                    :to="`/analisis-de-riesgos/fichas-de-control/formulario/${data.item.id}/${data.item.id_empresa}`">
                                    <i class="fa fa-list-ol" /> Fichas de control
                                </b-dropdown-item>

                                <b-dropdown-item v-if="permissions.includes('eliminar-tareas-analisis-riesgos')"
                                    variant="danger" @click="eliminarTarea(data.item)">
                                    <i class="fa fa-trash text-danger"></i> Eliminar
                                </b-dropdown-item>

                                <b-dropdown-divider />

                                <b-dropdown-item @click="obtainSafetyDataSheets(data.item.id_producto)">
                                    <i class="fa fa-file-text-o"></i> Ver ficha de seguridad
                                </b-dropdown-item>

                                <b-dropdown-item v-if="mostrar_filtro" @click="downloadControlSheet(data.item)">
                                    <i class="fa fa-download" /> Descargar ficha de control
                                </b-dropdown-item>

                                <b-dropdown-item v-if="mostrar_filtro" @click="downloadAnalysis(data.item)">
                                    <i class="fa fa-download" /> Descargar análisis
                                </b-dropdown-item>
                            </b-dropdown>
                        </template>
                    </b-table>
                </div>
            </div>

            <!-- Paginación -->
            <div class="row">
                <div class="col-12">
                    <el-pagination class="float-right" :page-sizes="[5, 30, 50, 100]" v-model="filtros.page"
                        @size-change="getPerPageAnalysis" @current-change="setPageAnalysis"
                        :current-page.sync="filtros.page" :page-size="filtros.per_page"
                        layout="total,sizes, prev, pager, next" :total="tareas.total" />
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <b-col md="12">
                <b-form-group>
                    <b-table responsive hover :items="analysisAiha.data" :fields="[
                        { key: 'select', label: '', thStyle: { width: '60px' } },
                        { key: 'id', label: 'ID' },
                        { key: 'hygienic_measurement.name', label: 'GES', thStyle: { width: '300px' } },
                        { key: 'hygienic_measurement.code', label: 'Código' },
                        { key: 'hygienic_measurement.code_short', label: 'Código abreviado' },
                        { key: 'created_at', label: 'Fecha y hora de analisis' },
                        { key: 'acciones', label: 'Acciones' }
                    ]" show-empty empty-text="No hay resultados para mostrar.">
                        <template v-slot:cell(select)="data">
                            <el-checkbox :value="filtros.ids.includes(data.item.id)"
                                @change="toggleIdFiltro(data.item.id)" />
                        </template>
                        <template #cell(hygienic_measurement.code_short)="row">
                            <span v-if="row.item.hygienic_measurement.code_short">
                                {{ row.item.hygienic_measurement.code_short }}
                            </span>
                            <span v-else>NO REGISTRA</span>
                        </template>
                        <template #cell(acciones)="row">
                            <router-link v-b-tooltip.hover title="Editar" class="accion ml-2"
                                :to="`/analisis-de-riesgos/analysis-aiha/${company_id}/${row.item.id}`">
                                <i class="fa fa-edit fa-lg text-primary" />
                            </router-link>
                            <a v-b-tooltip.hover title="Eliminar" class="accion ml-2"
                                @click="deleteAnalysisAiha(row.item.id)">
                                <i class="fa fa-trash fa-lg text-danger" />
                            </a>
                        </template>
                    </b-table>
                </b-form-group>
            </b-col>

            <b-col md="12">
                <b-form-group>
                    <div class="d-flex justify-content-end align-items-center pr-4">
                        <el-pagination style="max-width: 100%" v-model="filterAiha.page" :total="filterAiha.total"
                            :current-page="filterAiha.page" :page-size="Number(filterAiha.per_page)"
                            @size-change="afterChangeSizePagination" @current-change="afterChangePagePagination"
                            :page-sizes="[5, 30, 50, 100]" layout="total, sizes, prev, pager, next" />
                    </div>
                </b-form-group>
            </b-col>
        </div>

        <!-- Modal detalles adjuntos -->
        <modal_attachments v-if="modal_attachments.view" />

    </b-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import TreeSelect from '@riophae/vue-treeselect';
import { getAcls, validarPermisoComponente } from '../../../plugins/acl';
import modal_attachments from './modal_attachments';
import useCompanyCountries from '../../../composables/country/useCompanyCountries'
import useCompanyLocationsTree from '../../../composables/location/useCompanyLocationsTree'

export default {
    name: 'buscador',
    components: {
        TreeSelect,
        modal_attachments,
    },
    mixins: [useCompanyCountries, useCompanyLocationsTree],
    data() {
        return {
            mostrar_filtro: true,
            picker_options: {
                shortcuts: [
                    {
                        text: 'Ultima semana',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        },
                    },
                    {
                        text: 'Ultimo mes',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        },
                    },
                    {
                        text: 'Ultimas 3 semanas',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        },
                    },
                ],
            },
            validarPermisoComponente: validarPermisoComponente,
            permissions: [],
            types: [
                { id: 1, name: 'Análisis INRS' },
                { id: 2, name: 'Análisis AIHA' },
            ],
            company_id: null,
            country_id: null,
        };
    },
    async mounted() {
        let acls = getAcls();
        this.permissions = acls.permisos;
        await this.obtenerUsuarios();

        this.mostrar_filtro = !!acls.roles.filter((r) =>
            ['superadmin', 'admin', 'admin-tecnico'].includes(r)
        ).length;

        await this.getForCompany();

        if (this.filtros.type === 2) {
            if (this.company_id) {
                await this.getAnalysisAiha({ companyId: this.company_id });
                await this.fetchHygienicMeasurements(this.company_id);
            }
        }

        this.load(false);
        this.createUsabilityEvents('ingreso_modulo_ari');
    },
    computed: {
        ...mapState('tareas', [
            'tareas',
            'filtros',
            'empresas_filtro',
            'ubicaciones',
            'fabricantes_filtro',
            'productos',
            'usuarios',
            'productos_filtro',
            'modal_attachments',
        ]),

        ...mapState('analysis', [
            'productos',
        ]),

        ...mapState('aiha', [
            'analysisAiha',
            'filterAiha',
            'hygienicMeasurements',
        ]),
        usersOptions() {
            const base = [{ value: null, text: 'Seleccione una opción' }];
            const opts = Array.isArray(this.usuarios) ? this.usuarios.map(u => ({ value: u.id, text: u.name })) : [];
            return base.concat(opts);
        },

        columns() {
            const columns = [
                {
                    key: 'fecha',
                    label: 'Fecha',
                    sortable: false,
                },
                {
                    key: 'product.nombre',
                    label: 'Producto',
                    sortable: false,
                },
                {
                    key: 'ari_task.name',
                    label: 'Tarea',
                    sortable: false,
                },
                {
                    key: 'locations',
                    label: 'Ubicaciones',
                    sortable: false,
                },
                {
                    key: 'activo',
                    label: 'Estado',
                    sortable: false,
                },
                {
                    key: 'acciones',
                    label: 'Acciones',
                    sortable: false,
                    thStyle: 'max-width: 60px',
                    tdClass: 'text-center',
                },
            ];

            if (this.mostrar_filtro) {
                columns.unshift({
                    key: 'seleccion',
                    label: '',
                    sortable: false,
                });
            }

            return columns;
        },

        setTypes() {
            if (this.validarPermisoComponente('modulo-analisis-riesgos-aiha')) {
                return this.types;
            } else {
                return this.types.filter(type => type.id === 1);
            }
        },
        ...mapState('configurableVariables', ['allCountries']),
        ...mapState('location', ['treeWithChildrens']),
        ...mapState('autenticacion', ['my_company', 'locations_user']),
    },
    methods: {
        ...mapActions('analysis', [
            'obtenerTareas',
            'eliminarTarea',
            'obtenerEmpresasFiltro',
            'obtenerUbicacionesFiltro',
            'obtenerFabricantesFiltro',
            'obtenerProductosFiltro',
            'obtenerCargos',
            'obtenerGes',
            'obtenerUsuarios',
            'descargarExcel',
            'downloadControlSheet',
            'downloadAnalysis',
            'setPageAnalysis',
            'getPerPageAnalysis',
            'obtenerProductos',
        ]),
        ...mapActions('propiedades', [
            'obtenerUnidadesDeTemperatura',
            'obtenerUnidadesDePresion',
            'obtenerUnidadesDeViscosidad',
            'obtenerCapacidades',
        ]),
        ...mapMutations('analysis', [
            'establecerIdUbicacionFiltro',
            'establecerIdEmpresaFiltro',
            'establecerEmpresasFiltro',
            'clearFilters',
            'setDefaultTasks',
            'toggleIdFiltro',
            'setTypeAnalysis',
            'setFilterCompany',
        ]),
        ...mapActions('productos', [
            'obtainSafetyDataSheets'
        ]),
        ...mapActions('dashboard', ['validarPermiso', 'obtenerIdEmpresaUsuario']),
        ...mapMutations('dashboard', ['load']),

        ...mapActions("config_concepts", [
            'downloadRiskAnalysisConceptWord'
        ]),

        ...mapActions('aiha', [
            'getAnalysisAiha',
            'inactiveAnalysisAiha',
            'fetchHygienicMeasurements',
            'downloadAihaAnalysis',
        ]),

        ...mapMutations('aiha', [
            'setDefaultFilterAiha',
            'loadAfterChangeSizePagination',
            'loadAfterChangePagePagination',
            'setFiltersAnalysis',
            'setDefaultAnalysisAiha',
        ]),
        ...mapActions("usabilityEvents", ["createUsabilityEvents"]),

        async onHandleDownloadConcept() {
            await this.downloadRiskAnalysisConceptWord(this.filtros);
        },
        getLocations(locations) {
            return locations.map(item => item.description).join(", ");
        },
        async getForCompany() {
            this.filtros.ids = [];
            if (!this.mostrar_filtro) {
                const id_empresa = await this.obtenerIdEmpresaUsuario();
                this.company_id = id_empresa;
                this.setFilterCompany(id_empresa);
                await this.getAllCountriesByCompany(id_empresa);

                // Aplicar selección automática después de cargar el árbol
                if (this.locations_user && this.locations_user.length > 0) {
                    const selectedLocationIds = await this.loadLocationsTreeWithMultipleAutoSelect(id_empresa, this.locations_user, null, this.my_company);
                    if (selectedLocationIds && selectedLocationIds.length > 0) {
                        this.establecerIdUbicacionFiltro(selectedLocationIds);
                    }
                } else {
                    await this.loadLocationsTree(id_empresa, null);
                }

                this.establecerIdEmpresaFiltro(id_empresa);
                await this.obtenerTareas();
                if (this.tareas.data.length) {
                    this.establecerEmpresasFiltro([this.tareas.data[0].company]);
                }
            } else {
                this.company_id = this.filtros.id_empresa;
            }

            if (this.filtros.type === 2) {
                if (this.company_id) {
                    await this.getAnalysisAiha({ companyId: this.company_id });
                    await this.fetchHygienicMeasurements(this.company_id);
                }
            }
        },
        async filterClear() {
            let type = this.filtros.type;
            this.setDefaultTasks();
            this.setDefaultFilterAiha();
            this.setDefaultAnalysisAiha();
            await this.clearFilters();
            if (type === 2) {
                this.setTypeAnalysis(2);
            }
            await this.getForCompany();
        },

        async changeCompany() {
            if (this.filtros.type === 1) {
                this.country_id = null;
                this.establecerIdUbicacionFiltro([]);

                if (this.filtros.id_empresa) {
                    await this.getAllCountriesByCompany(this.filtros.id_empresa);

                    // Aplicar selección automática después de cargar el árbol
                    if (this.locations_user && this.locations_user.length > 0) {
                        const selectedLocationIds = await this.loadLocationsTreeWithMultipleAutoSelect(this.filtros.id_empresa, this.locations_user, null, this.my_company);
                        if (selectedLocationIds && selectedLocationIds.length > 0) {
                            this.establecerIdUbicacionFiltro(selectedLocationIds);
                        }
                    } else {
                        await this.loadLocationsTree(this.filtros.id_empresa, null);
                    }
                }
                this.filtros.ids = [];
            } else {
                if (this.filtros.id_empresa) {
                    this.filtros.hygienic_measurement_id = null;
                    this.setDefaultFilterAiha();
                    await this.fetchHygienicMeasurements(this.filtros.id_empresa);
                }
            }

            this.setDefaultTasks();
            this.setDefaultAnalysisAiha();


            if (this.filtros.id_empresa) {
                await this.search();
            }
        },

        async search() {
            this.filtros.ids = [];
            this.company_id = this.filtros.id_empresa;
            if (this.filtros.type === 1) {
                await this.obtenerTareas();
            } else {
                await this.getAnalysisAiha({ companyId: this.filtros.id_empresa, reloadPage: true });
            }
        },

        normalizer(node) {
            return {
                id: node.id,
                label: node.label,
                children: Array.isArray(node.children) && node.children.length ? node.children : undefined,
                raw: node,
            };
        },

        async afterChangeSizePagination(size) {
            this.loadAfterChangeSizePagination(size);
            await this.getAnalysisAiha({ companyId: this.filtros.id_empresa });
        },

        async afterChangePagePagination(page) {
            this.loadAfterChangePagePagination(page);
            await this.getAnalysisAiha({ companyId: this.filtros.id_empresa });
        },

        async filtersAnalysis() {
            await this.setFiltersAnalysis({
                fechas: this.filtros.fechas,
                hygienic_measurement_id: this.filtros.hygienic_measurement_id,
                ids: this.filtros.ids,
            });
        },

        async afterChangeCountry() {
            if (this.filtros.id_empresa && this.filtros.type === 1) {
                this.establecerIdUbicacionFiltro([]);

                // Cargar ubicaciones con selección automática si el usuario tiene ubicaciones asignadas
                if (this.locations_user && this.locations_user.length > 0) {
                    const selectedLocationIds = await this.loadLocationsTreeWithMultipleAutoSelect(this.filtros.id_empresa, this.locations_user, this.country_id || null, this.my_company);
                    if (selectedLocationIds && selectedLocationIds.length > 0) {
                        this.establecerIdUbicacionFiltro(selectedLocationIds);
                    }
                } else {
                    await this.loadLocationsTree(this.filtros.id_empresa, this.country_id || null);
                }
            }
        },

        async deleteAnalysisAiha(id) {
            const confirm = await new Promise(resolve => {
                this.$alertConfirmation({
                    icon: 'warning',
                    title: '¡Información!',
                    text: '¿Está seguro de eliminar el análisis?',
                    showConfirmButton: true,
                    showCancelButton: true,
                    onConfirm: () => resolve(true),
                    onCancel: () => resolve(false),
                    onDismiss: () => resolve(false)
                });
            });
            if (!confirm) return;

            await this.inactiveAnalysisAiha({ companyId: this.filtros.id_empresa, analysisId: id });
            await this.getAnalysisAiha({ companyId: this.filtros.id_empresa });
        },

        async downloadExcelAiha() {
            await this.filtersAnalysis();
            await this.downloadAihaAnalysis(this.filtros.id_empresa);
        },
    },
};
</script>

<style src="../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>

<style scoped>
.form-input-group {
    height: 32px !important;
}

.el-select-personalizado {
    max-width: 400px;
}

.trash_icon {
    cursor: pointer;
    color: #20a8d8 !important;
}

.vue-treeselect__no-children-tip {
    display: none;
}

.el-select-dropdown {
    max-width: 500px;
}

.el-select-dropdown .el-select-dropdown__item {
    /* Permite que el texto salte a la siguiente línea si no cabe */
    white-space: normal;
    /* Anula la altura fija del item para que pueda crecer verticalmente */
    height: auto;
    /* Mejora el espacio entre las líneas para que el texto sea más legible */
    line-height: 1.5;
    /* (Opcional) Un pequeño ajuste de padding para que se vea mejor verticalmente */
    padding-top: 8px;
    padding-bottom: 8px;
}
</style>

<style scoped>
.text-blue {
    color: rgb(29, 109, 180);
}

.text-green {
    color: rgb(26, 169, 71);
}
</style>
